export interface ITriggerCustomerDto {
    type: string;
    datetime: string;
    tripId: string;
    locationId: string;
    zoneId?: string;
    origin?: string;
}
